"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const App_1 = require("./App");
const Codable_1 = require("./Codable");
const Field_1 = require("./Field");
const File_1 = require("./File");
const util_1 = require("./util");
class Model {
    constructor() {
        this._data = {};
        for (const field of this.fields()) {
            this._defineField(field);
        }
    }
    static model() {
        const type = this;
        return type;
    }
    static init() {
        const model = new this();
        return model;
    }
    static from(data, option = { convertDocumentReference: false }) {
        const model = new this();
        model._set(data, option);
        return model;
    }
    codingKeys() {
        const fields = this.fields();
        const keys = {};
        for (const field of fields) {
            keys[field] = field;
        }
        return keys;
    }
    fields() {
        return Reflect.getMetadata(Field_1.FieldSymbol, this) || [];
    }
    _set(data, option) {
        for (const field of this.fields()) {
            const codingKey = this.codingKeys()[field];
            const value = data[codingKey];
            if (value === undefined) {
                this._data[field] = null;
            }
            else {
                this._data[field] = this._decode(value, field, option);
            }
        }
    }
    data(option) {
        let data = {};
        for (const field of this.fields()) {
            const codingKey = this.codingKeys()[field];
            const descriptor = Object.getOwnPropertyDescriptor(this, field);
            if (descriptor && descriptor.get) {
                const value = descriptor.get();
                data[codingKey] = this._encode(value, field, option);
            }
            else {
                data[codingKey] = null;
            }
        }
        return data;
    }
    _encode(value, key, option) {
        const convertDocumentReference = (option === null || option === void 0 ? void 0 : option.convertDocumentReference) || false;
        if (File_1.File.is(value)) {
            return value.data(option);
        }
        else if (value instanceof Model) {
            return value.data(option);
        }
        else if (value instanceof Array) {
            let container = [];
            for (const i of value) {
                container.push(this._encode(i, key, option));
            }
            return container;
        }
        else if (util_1.isDocumentReference(value) && convertDocumentReference) {
            const ref = value;
            const firestore = ref.firestore;
            const projectId = firestore._projectId || firestore.app.options.projectId;
            return {
                projectId: projectId,
                path: ref.path
            };
        }
        else {
            return value;
        }
    }
    _decode(value, key, option) {
        const convertDocumentReference = (option === null || option === void 0 ? void 0 : option.convertDocumentReference) || false;
        if (File_1.File.is(value)) {
            return File_1.File.from(value);
        }
        else if (value instanceof Array) {
            let container = [];
            for (const i of value) {
                container.push(this._decode(i, key, option));
            }
            return container;
        }
        else if (util_1.isDocumentReference(value) && convertDocumentReference) {
            return App_1.App.shared().firestore().doc(value.path);
        }
        else if (value instanceof Object) {
            const codingKeys = Reflect.getMetadata(Codable_1.CodableSymbol, this) || {};
            const modelType = codingKeys[key];
            if (modelType) {
                const model = new modelType.type();
                model._set(value, option);
                return model;
            }
            else {
                return value;
            }
        }
        else {
            return value;
        }
    }
    _defineField(key, value) {
        const descriptor = {
            enumerable: true,
            configurable: true,
            get: () => {
                if (this._data) {
                    if (this._data[key] === undefined) {
                        return null;
                    }
                    return this._data[key];
                }
                else {
                    return undefined;
                }
            },
            set: (newValue) => {
                if (this._data) {
                    this._data[key] = newValue;
                }
                else {
                    fail(`[Ballcap: Document] This document has not data. key: ${key} value: ${newValue}`);
                }
            }
        };
        Object.defineProperty(this, key, descriptor);
    }
}
exports.Model = Model;
//# sourceMappingURL=Model.js.map